import moment from 'moment';
import { useQueries, UseQueryResult } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest, resolveQueryString } from 'src/utils/request';
import { forceString } from 'src/utils/datetime';

const mapPayrolls = (
  data: UseQueryResult<
    {
      data: Array<UCM.PayrollDataRawType>;
      meta: UCM.PayrollMetaRawType;
      filters: Record<string, string>;
    },
    unknown
  >[],
) => {
  if (!data?.length) return { id: '', data: [], isPending: false };

  const flatResults = data.map((item) => {
    if (!item.data)
      return {
        data: [],
        meta: {},
      };
    const {
      data: { data, meta, filters },
    } = item;
    return {
      id: filters.date,
      data: data.map(({ attributes, id }) => ({
        id,
        createdAt: forceString(attributes.created_at),
        groupNumber: attributes.group_number,
        objectKey: attributes.object_key,
        referenceDate: attributes.reference_date,
        sequence: attributes.sequence,
        uuid: attributes.uuid,
      })),
      meta: {
        notReadyCount: meta.not_ready_count,
        paidCount: meta.paid_count,
        readyCount: meta.ready_count,
        dateAsString: filters.date,
        date: moment(filters.date),
      },
    };
  });

  const isPending = data.some((item) => item.isPending);

  return {
    data: flatResults,
    isPending,
  };
};

const getPayrolls = async (filters: Record<string, string>) => {
  const query = resolveQueryString([filters]);
  const {
    data: { data, meta },
  } = await getRequest(API.GET.getPayrolls(query));

  return { data, meta, filters };
};

export const useGetPayrolls = ({
  dates,
  enabled = false,
}: {
  dates: Array<string>;
  enabled?: boolean;
}) => {
  return useQueries({
    queries: dates?.map((date) => {
      return {
        queryKey: [QUERY_KEYS.PAYROLLS, date],
        queryFn: () => getPayrolls({ date }),
        enabled,
      };
    }),
    combine: (results) => {
      return mapPayrolls(results);
    },
  });
};
